import QuestionList from "pages/QuestionPage/QuestionNavigator/QuestionNavigator";

export default QuestionList;
